"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _Info = _interopRequireDefault(require("@material-ui/icons/Info"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _colors = require("@material-ui/core/colors");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));

var _SnackbarContent = _interopRequireDefault(require("@material-ui/core/SnackbarContent"));

var _Warning = _interopRequireDefault(require("@material-ui/icons/Warning"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    success: {
      backgroundColor: _colors.green[600]
    },
    error: {
      backgroundColor: theme.palette.error.dark
    },
    info: {
      backgroundColor: theme.palette.primary.main
    },
    warning: {
      backgroundColor: _colors.amber[700]
    },
    icon: {
      fontSize: 20
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing(1)
    },
    message: {
      display: 'flex',
      alignItems: 'center'
    },
    root: {
      maxWidth: 320
    }
  };
});
var variantIcon = {
  success: _CheckCircle.default,
  warning: _Warning.default,
  error: _Error.default,
  info: _Info.default
};

var Toast = function Toast(props) {
  var className = props.className,
      message = props.message,
      onClose = props.onClose,
      variant = props.variant,
      onRequestClose = props.onRequestClose,
      autoHideDuration = props.autoHideDuration,
      anchorOrigin = props.anchorOrigin,
      other = _objectWithoutProperties(props, ["className", "message", "onClose", "variant", "onRequestClose", "autoHideDuration", "anchorOrigin"]);

  var classes = useStyles();
  var Icon = variantIcon[variant];
  return _react.default.createElement(_Snackbar.default, {
    className: "".concat(classes.root, " ").concat(className),
    anchorOrigin: anchorOrigin,
    open: true,
    autoHideDuration: autoHideDuration,
    onClose: onRequestClose
  }, _react.default.createElement(_SnackbarContent.default, _extends({
    className: classes[variant],
    "aria-describedby": 'client-snackbar',
    message: _react.default.createElement("span", {
      id: 'client-snackbar',
      className: classes.message
    }, _react.default.createElement(Icon, {
      className: "".concat(classes.icon, " ").concat(classes.iconVariant)
    }), message),
    action: [_react.default.createElement(_IconButton.default, {
      key: 'close',
      "aria-label": 'close',
      color: 'inherit',
      onClick: onClose
    }, _react.default.createElement(_Close.default, {
      className: classes.icon
    }))]
  }, other)));
};

Toast.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  autoHideDuration: null,
  variant: 'info'
};
Toast.propTypes = {
  className: _propTypes.default.string,
  message: _propTypes.default.string,
  onClose: _propTypes.default.func,
  onRequestClose: _propTypes.default.func,
  anchorOrigin: _propTypes.default.object,
  autoHideDuration: _propTypes.default.number,
  variant: _propTypes.default.oneOf(['error', 'info', 'success', 'warning']).isRequired
};
var _default = Toast;
exports.default = _default;